import type { Variants } from "framer-motion";

export const MainPageAnimation: Variants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      duration: 0.5,
      when: "beforeChildren",
      staggerChildren: 0.5,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};

export const PagesAnimation: Variants = {
  hidden: {
    opacity: 1,
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
    },
  },
  exit: { opacity: 1 },
};

export const SlideAnimation: Variants = {
  hidden: {
    opacity: 0,
    x: "-100%",
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      type: "spring",
      stiffness: 150,
    },
  },
  exit: {
    opacity: 0,
    x: "100%",
    transition: {
      duration: 0.3,
    },
  },
};

export const FadeInAnimation: Variants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      duration: 0.2,
      when: "beforeChildren",
      staggerChildren: 0.12,
    },
  },
};

export const FadeUpAnimation: Variants = {
  hidden: {
    opacity: 0,
    y: "100%",
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
};

export const FadeDownAnimation: Variants = {
  hidden: {
    opacity: 0,
    y: "-100%",
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
};
export const FadeRightAnimation: Variants = {
  hidden: {
    opacity: 0,
    x: "-100%",
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
    },
  },
};

export const FadeLeftAnimation: Variants = {
  hidden: {
    opacity: 0,
    x: "100%",
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
    },
  },
};

export const ScaleInAnimation: Variants = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      // stiffness: 100,
    },
  },
};

export const DropdownAnimation: Variants = {
  hidden: {
    display: "none",
  },
  show: {
    display: "block",
    transition: {
      when: "beforeChildren",
    },
  },
  exit: {
    display: "none",
    transition: {
      when: "afterChildren",
    },
  },
};

export const MenuAnimation: Variants = {
  hidden: {
    opacity: 0,
    y: -500,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    y: -500,
    transition: {
      duration: 0.3,
    },
  },
};

export const BurgerMenuAnimation: Variants = {
  hidden: {
    opacity: 0,
    visibility: "hidden",
    scale: 5,
    transition: {
      duration: 0.5,
    },
  },
  show: {
    opacity: 1,
    visibility: "visible",
    scale: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    visibility: "hidden",
    scale: 50,
    transition: {
      duration: 0.5,
    },
  },
};
